import * as ActionTypes from "services/state/action-types";

const initialState = {
  sensediaCorpToken: "",
  loginCorpError: false,
};

const sensediaCorpAuth = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SENSEDIA_CORP_ACCESS_TOKEN: {
      return {
        ...state,
        sensediaCorpToken: payload,
      };
    }
    default:
      return state;
  }
};

export default sensediaCorpAuth;



// WEBPACK FOOTER //
// ./src/services/state/sensediaCorp/reducer.js